export default {"src":"/_next/static/media/CCL.fd69ad02.svg","height":18,"width":18};